<template>
<section>
  <div class="py-6 px-8">
      <p class="uppercase text-4xl text-gray-400 uppercase font-bold">
          <span class="text-[#090446]">Customer Support</span>
      </p>
  </div>

  <div class="px-8 py-6 border-2 mx-8 my-6 rounded-[18px] bg-white">
      <div>
          <p class="mt-6 mx-2 inline-flex items-center">
              <span class="ml-2">
                  <svg class="h-6 w-6" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M27.9868 12.5459C28.0314 13.607 27.651 14.6424 26.9289 15.4249C26.2068 16.2074 25.2021 16.6732 24.1351 16.72C24.0727 16.7229 24.0104 16.7243 23.9482 16.7243C23.6647 16.7241 23.3821 16.6936 23.1051 16.6333C22.2834 17.8949 21.2059 18.9721 19.9416 19.7959C18.6772 20.6197 17.2539 21.172 15.7626 21.4176C15.5862 21.9329 15.2343 22.3706 14.7677 22.6553C14.3012 22.9399 13.7492 23.0535 13.2074 22.9765C12.6655 22.8994 12.1677 22.6365 11.8001 22.2332C11.4325 21.8299 11.2181 21.3116 11.1941 20.7678C11.1701 20.224 11.3378 19.689 11.6684 19.2551C11.9991 18.8213 12.4717 18.516 13.0047 18.3919C13.5377 18.2679 14.0975 18.3329 14.5874 18.5757C15.0773 18.8186 15.4664 19.224 15.6876 19.7218C17.7872 19.3357 19.6839 18.2293 21.0472 16.5953C22.4105 14.9614 23.154 12.9035 23.148 10.7804C23.148 5.76462 19.0443 1.684 14 1.684C8.95575 1.684 4.85199 5.76462 4.85199 10.7804C4.85171 12.3314 5.25034 13.8567 6.00998 15.2113C6.03573 15.256 6.05505 15.304 6.0674 15.3541C6.14077 15.5568 6.13293 15.7799 6.04549 15.9771C5.95805 16.1743 5.79771 16.3305 5.59766 16.4135C5.1078 16.6185 4.58168 16.724 4.0502 16.7239C3.98765 16.7239 3.92497 16.7225 3.86216 16.7196C2.79561 16.6722 1.79149 16.2062 1.06997 15.4237C0.348452 14.6412 -0.0315729 13.6062 0.0132228 12.5455C0.0312309 12.1226 0.0211825 11.7452 0.0113599 11.3803C0.00221469 11.0367 -0.00732563 10.6813 0.00836796 10.3106C0.0552047 9.27495 0.503221 8.29751 1.25858 7.58298C2.01394 6.86845 3.01805 6.47227 4.06059 6.4774C5.73472 2.66864 9.5595 0 14 0C18.4405 0 22.2653 2.66864 23.9395 6.47746C24.9821 6.47155 25.9865 6.86739 26.742 7.58193C27.4975 8.29648 27.9454 9.2742 27.9916 10.31C28.0073 10.6813 27.9978 11.0366 27.9886 11.3801C27.9789 11.7451 27.9688 12.1227 27.9868 12.5459ZM21.1019 10.7804C21.1015 11.8623 20.8512 12.9296 20.3703 13.9001C19.8895 14.8706 19.1908 15.7183 18.3284 16.3778C17.4659 17.0374 16.4626 17.4911 15.3959 17.7041C14.3292 17.9171 13.2275 17.8836 12.1758 17.6062L9.30124 19.257C9.15619 19.3402 8.98957 19.3789 8.82244 19.368C8.65531 19.3571 8.49517 19.2972 8.36229 19.1958C8.22941 19.0944 8.12975 18.9561 8.07592 18.7984C8.02209 18.6407 8.0165 18.4707 8.05986 18.3098L8.79453 15.5846C7.57788 14.277 6.90093 12.5618 6.89837 10.7804C6.89837 6.88543 10.084 3.71693 14 3.71693C17.916 3.71693 21.1019 6.88543 21.1019 10.7804ZM12.0256 10.7804C12.0256 10.5571 11.9364 10.3429 11.7776 10.185C11.6188 10.0271 11.4034 9.93842 11.1788 9.93842H11.1774C11.01 9.93873 10.8464 9.98837 10.7074 10.0811C10.5684 10.1738 10.4601 10.3054 10.3962 10.4593C10.3324 10.6132 10.3158 10.7824 10.3487 10.9456C10.3815 11.1089 10.4623 11.2588 10.5808 11.3764C10.6993 11.494 10.8502 11.574 11.0144 11.6064C11.1786 11.6387 11.3488 11.6219 11.5034 11.5582C11.658 11.4944 11.7902 11.3865 11.8832 11.248C11.9761 11.1096 12.0258 10.9469 12.0258 10.7804H12.0256ZM14.8469 10.7804C14.8469 10.7529 14.8454 10.7253 14.8424 10.6979C14.8398 10.6704 14.8356 10.643 14.8301 10.6159C14.825 10.589 14.8182 10.5623 14.8097 10.5362C14.8018 10.5099 14.7922 10.484 14.7821 10.4582C14.7719 10.4324 14.7595 10.4083 14.7465 10.3841C14.7336 10.3598 14.7195 10.3362 14.7042 10.3134C14.6887 10.2903 14.6721 10.268 14.6544 10.2466C14.637 10.2251 14.6184 10.2047 14.5986 10.1854C14.5794 10.1658 14.5585 10.1472 14.5371 10.1293C14.5156 10.1124 14.493 10.0956 14.4698 10.0804C14.4469 10.0652 14.4232 10.0512 14.3988 10.0383C14.3744 10.0254 14.3491 10.0136 14.3236 10.003C14.2982 9.99238 14.2722 9.9832 14.2458 9.97546C14.193 9.9586 14.1385 9.94768 14.0832 9.94291C14.0003 9.93497 13.9166 9.93894 13.8348 9.95469C13.8076 9.96022 13.7807 9.96716 13.7542 9.97546C13.7277 9.98319 13.7017 9.99237 13.6762 10.003C13.6508 10.0136 13.6254 10.0254 13.6012 10.0383C13.5769 10.0512 13.5532 10.0653 13.53 10.0804C13.5068 10.0956 13.4843 10.1124 13.4634 10.1293C13.4414 10.1472 13.4211 10.1658 13.4013 10.1854C13.3815 10.2047 13.3628 10.2251 13.3454 10.2466C13.3279 10.268 13.3115 10.2903 13.2963 10.3134C13.2808 10.3362 13.2665 10.3598 13.2534 10.3841C13.2404 10.4082 13.2287 10.4329 13.2184 10.4582C13.2077 10.4837 13.1982 10.5098 13.1901 10.5362C13.1823 10.5621 13.1755 10.589 13.1699 10.6159C13.1643 10.643 13.1601 10.6704 13.1574 10.6979C13.1546 10.7254 13.1535 10.7529 13.1535 10.7804C13.1535 10.8079 13.1546 10.836 13.1574 10.8635C13.1602 10.8908 13.1643 10.918 13.1699 10.9449C13.1755 10.9718 13.1823 10.9988 13.1901 11.0252C13.1982 11.0514 13.2077 11.0773 13.2184 11.1026C13.2287 11.1281 13.2404 11.153 13.2534 11.1773C13.2664 11.2014 13.2811 11.225 13.2963 11.248C13.3115 11.2709 13.3279 11.293 13.3454 11.3142C13.363 11.3358 13.3816 11.3564 13.4013 11.376C13.4211 11.3951 13.4414 11.4142 13.4634 11.4316C13.4847 11.4491 13.5069 11.4654 13.53 11.4804C13.5532 11.4956 13.5768 11.5102 13.6012 11.5231C13.6502 11.5485 13.7014 11.5695 13.7542 11.5859C13.7806 11.5938 13.8077 11.6005 13.8348 11.6061C13.8892 11.6172 13.9447 11.6227 14.0002 11.6224C14.2245 11.6218 14.4396 11.5333 14.5986 11.376C14.6376 11.3366 14.673 11.2938 14.7042 11.248C14.7194 11.225 14.7335 11.2014 14.7465 11.1773C14.7595 11.1531 14.7714 11.1279 14.7821 11.1026C14.7928 11.0774 14.8018 11.051 14.8097 11.0252C14.8181 10.9988 14.8249 10.972 14.8301 10.9449C14.8356 10.918 14.8397 10.8908 14.8424 10.8635C14.8453 10.8359 14.8468 10.8081 14.8468 10.7803L14.8469 10.7804ZM17.6695 10.7804C17.6695 10.5571 17.5803 10.3429 17.4215 10.185C17.2627 10.0271 17.0473 9.93842 16.8228 9.93842H16.8211C16.6537 9.93874 16.4902 9.98839 16.3511 10.0811C16.2121 10.1738 16.1038 10.3054 16.04 10.4593C15.9761 10.6132 15.9596 10.7825 15.9925 10.9457C16.0253 11.1089 16.1061 11.2588 16.2246 11.3764C16.3431 11.494 16.4939 11.574 16.6582 11.6064C16.8224 11.6387 16.9926 11.6219 17.1472 11.5582C17.3018 11.4944 17.434 11.3865 17.5269 11.248C17.6199 11.1096 17.6695 10.9469 17.6695 10.7804Z"
                          fill="#4C4C4D" />
                  </svg>

              </span>
              <span class="ml-2 text-lg font-bold text-gray-700"> Ask a question ?</span>
          </p>

          <form class="items-center px-8">
              <div class="relative w-full space-y-4">
                  <textarea rows="6"
                      class="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500" id="ask-question" v-model="askQuestion.description" placeholder="Ask Your Care Team"></textarea>
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" type="button" :disabled="askQuestion.disabled" @click="submitAskQuestion">
                      Submit
                  </button>
              </div>
          </form>

      </div>
  </div>

  <div class="p-10 py-6 border-2 mx-8 my-6 rounded-[18px] bg-white" v-if="authUser.role == 'COMPANY_ADMIN'">
      <p class="uppercase text-[#0A0446] text-[24px] uppercase font-bold my-2">SUPPORT REQUESTS FROM MY TEAM</p>

      <div class="divide-y" >
          <div class="py-4 space-y-3" v-if="questionListLength" v-for="r in questionList.data" v-bind:key="r.id">
              <p class="font-bold text-xl text-[#BE0858]">{{ r.first_name }} {{ r.last_name }}</p>
              <p class="text-black text-justify">{{ r.description }}</p>
              <p class="font-bold text-black">Date: {{ r.created_at | timeStampToDateOnly }} {{r.created_at | timeStampToTimeOnly}}</p>
              <div class="flex flex-wrap items-center space-x-2">
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" v-if="!r.forward_to_admin && (user.role == 'ADMIN' || (company && company.role == 'COMPANY_ADMIN'))" @click="forwardToAdmin(r.id)">
                      Forward to Mpact
                  </button>
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" v-if="r.forward_to_admin && (user.role == 'ADMIN' || (company && company.role == 'COMPANY_ADMIN'))">
                      Forwarded to Mpact
                  </button>
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" v-if="((user.role == 'ADMIN'  && !r.response)|| (company && company.role == 'COMPANY_ADMIN'  && !r.response && r.company_id != company.id))" v-b-modal.response-modal @click="respondQuestion(r.id)">
                      Respond
                  </button>
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" v-if="((user.role == 'ADMIN' && r.response)|| (company && company.role == 'COMPANY_ADMIN' && r.response))">
                      Responded
                  </button>
                  <button
                      class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black" @click="archiveQuestion(r.id)">
                      Archive
                  </button>
                  <router-link :to="'view-question/' + r.id">
                      <button
                          class="m-1 flex items-center font-sixe-[20px] px-12 py-1  rounded-md bg-[#0A0446] text-white text-center text-md border border-1 border-black">
                          View
                      </button>
                  </router-link>
              </div>
          </div>
      </div>
  </div>

  <div class="py-6 px-8" v-if="authUser.role == 'COMPANY_EMP'">
      <p class="uppercase text-[36px] text-gray-400 uppercase font-bold">
          <span class="text-[#090446]">Questions & Answers</span>
      </p>
  </div>

  <div class="" v-if="authUser.role == 'COMPANY_EMP'">
      <div class="container px-8 py-4 mx-auto">
          <div class="">
              <div class="border-2 border-gray-100 rounded-lg bg-white" v-if="questionListLength" v-for="(r, index) in questionList.data" v-bind:key="r.id">
                  <button class="flex items-center justify-between w-full p-8" id="question-1"
                      @click="abc = toggleAnswer(index);">
                      <h1 class="font-semibold flex items-center">
                          <span class="font-semibold text-gray-700 text-[#3C3C43]"
                              style="font-size: xxx-large;"> {{index+1}} </span>
                          <span class="ml-6 font-semibold text-black">{{ r.description }}</span>
                      </h1>
                      <!--<span class="faq-icon text-gray-400 bg-gray-200 rounded-full">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
                              viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                          </svg>
                      </span> -->
                  </button>

                  <hr class="border-gray-200">
                  
                  <!--<p id="question-1-body" class="ml-16 faq p-8 text-lg text-black">{{ r.company_name }}:</p>-->
                  <p id="question-1-body" class="ml-16 faq p-8 text-lg text-black" v-if="r.expanded" v-html="r.response ? (r.response) : 'NA'"></p>
              </div>
          </div>
      </div>
  </div>

  <b-modal id="response-modal" size="lg" title="Respond to Question" :hide-footer=hideFooter no-enforce-focus>
    <div class="form-group">
      <label>Response <span class="err">*</span></label>
      <vue2-tinymce-editor v-model="response.response" placeholder="Response"></vue2-tinymce-editor>

      <!-- <textarea class="form-control" id="respond" placeholder="Response" v-model="response.response"></textarea> -->
    </div>
    <button type="button" class="btn btn-primary" @click="submitResponse" :disabled="response.disabled">Submit
    </button>
  </b-modal>

</section>
</template>

<script>
/* eslint-disable */
import Api from '../../../router/api'
import AppMixin from '../../../mixins/AppMixin'
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  name: 'AskQuestion',
  data() {
    return {
      questionList: {},
      questionListLength: 0,
      askQuestion: {
        description: '',
        disabled: false
      },
      hideFooter: true,
      msg: 'Ask Your Care Team',
      response: {
        questionId: '',
        response: '',
        disabled: false
      },
      type:""
    }
  },
  components: {
    Vue2TinymceEditor
  },
  mixins: [AppMixin],
  methods: {
    respondQuestion: function (id) {
      let that = this;
      that.response.questionId = id
    },
    submitResponse: function () {
      let that = this;
      if (!that.response.response) {
        this.$swal({
          icon: "error",
          title: "error",
          text: "Please enter response",
          showConfirmButton: true
        });
      } else {
        Api.submitResponse(that.response).then(response => {
          that.$swal({
            icon: "success",
            title: "Success",
            text: "Responded successfully",
            showConfirmButton: true
          }).then(function () {
            that.$bvModal.hide('response-modal')
            that.response.response = ''
            that.getQuestionList();
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: "error",
            text: error.response.data.message,
            showConfirmButton: true
          }).then(function () {
          });
        });
      }
    },
    submitAskQuestion: function () {
      let that = this
      if (!that.askQuestion.description) {
        this.$swal({
          icon: "error",
          title: "error",
          text: "Please fill all required fields",
          showConfirmButton: true
        })
      } else {
        that.askQuestion.disabled = true
        that.askQuestion.role = that.company.role
        Api.submitAskQuestion(that.askQuestion).then(response => {
          that.askQuestion.disabled = false
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Submitted successfully",
            showConfirmButton: true
          }).then(function () {
            that.askQuestion.disabled = false
            that.askQuestion.description = ''
          });
        }).catch((error) => { 
          that.askQuestion.disabled = false
          this.$swal({
            icon: 'error',
            title: 'error',
            text: error.response.data.message,
            showConfirmButton: true
          })
        })
      }
    },
    getQuestionList: function (page = 1) {
      let that = this;
      Api.getQuestionList(page, that.searchData).then(response => {
        that.questionList = response.data.res
        that.questionListLength = that.questionList.data.length
        for (let i = 0; i < that.questionListLength; i++) {
          that.questionList.data[i].expanded = true;
        }
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "error",
          text: error.response.data.message,
          showConfirmButton: true
        }).then(function () {
        });
      });
    },
    archiveQuestion: function (id) {
      let that = this;
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to archive this question? You wont be able to revert it',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          Api.archiveQuestion(id).then(response => {
            that.$swal({
              icon: "success",
              title: "Success",
              text: "Archived successfully",
              showConfirmButton: true
            }).then(function () {
              that.getQuestionList();
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "error",
              text: error.response.data.message,
              showConfirmButton: true
            }).then(function () {
            });
          });
        }
      });
    },
    toggleAnswer(index) {  
      this.questionList.data[index].expanded = !this.questionList.data[index].expanded;
      //alert(this.questionList.data[index].expanded)
    },
    forwardToAdmin: function (id) {
      let that = this;
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to forward this question to super admin',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          Api.forwardToAdmin(id).then(response => {
            that.$swal({
              icon: "success",
              title: "Success",
              text: "Forwarded successfully",
              showConfirmButton: true
            }).then(function () {
              that.getQuestionList();
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "error",
              text: error.response.data.message,
              showConfirmButton: true
            }).then(function () {
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getQuestionList()
  },
  created() {
    this.getAuthUser()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/common/customer-support/AskQuestion.vue